/** Плашка таймлайна на флоу-ноде: шире карточки, но не дальше длины ролика. */

/** Уже нынешних 360px, чтобы короткий ролик не сжимался в полоску. */
export const FLOW_TIMELINE_MIN_W = 480
/** Насколько плашка шире самой ноды, пока не упёрлась в потолок длительности. */
export const FLOW_TIMELINE_NODE_EXTRA = 48
/** Паддинг плашки (p-2). */
export const FLOW_TIMELINE_CHROME_W = 16
/** Комфортная плотность: примерно один кадр 16:9 на секунду, без длинного хвоста. */
export const FLOW_TIMELINE_MAX_PX_PER_SEC = 120

export function flowTimelinePlaqueWidth(nodeWidth: number, durationMs: number): number {
  const width = Number.isFinite(nodeWidth) ? Math.max(0, nodeWidth) : 0
  const grown = Math.max(FLOW_TIMELINE_MIN_W, width + FLOW_TIMELINE_NODE_EXTRA)
  const seconds = Number.isFinite(durationMs) ? Math.max(durationMs, 0) / 1000 : 0
  const cap = Math.max(FLOW_TIMELINE_MIN_W, FLOW_TIMELINE_CHROME_W + seconds * FLOW_TIMELINE_MAX_PX_PER_SEC)
  return Math.round(Math.min(grown, cap))
}
